import React from 'react'

function Photoshop() {
  return (
    <div>Photoshop</div>
  )
}

export default Photoshop